<div mat-dialog-title class="dialog-header">
  <h3 class="dialog-title">Merge Department</h3>
  <button type="button" mat-icon-button tabindex="-1" (click)="onCloseClick()"><mat-icon>close</mat-icon></button>
</div>
<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <mat-dialog-content>
    <h5
      >Department <b>{{ sourceDepartmentName }}</b> will be deactivated and all extensions will be moved to:</h5
      >
      <mat-form-field>
        <mat-label>Destination Department</mat-label>
        <input
          class="empty-option-placeholder"
          [lcsSingleSelect]="departmentSelect"
          ndtDepartmentSelect
          autocomplete="off"
          formControlName="destinationDepartment"
          type="text"
          [accountId]="accountId"
          id="merge-department-destination-department"
          />
          @if (form.get('destinationDepartment')?.hasError('required')) {
            <mat-error
              >Please select a department</mat-error
              >
          }
        </mat-form-field>
        <ndt-department-select
          #departmentSelect
          (optionSelected)="selected($event)"
          [departmentsToExclude]="sourceDepartments"
        ></ndt-department-select>
      </mat-dialog-content>
      <mat-dialog-actions>
        <button type="submit" title="Create" mat-raised-button>Save</button>
      </mat-dialog-actions>
    </form>
